import { combineReducers } from "redux";
import invitationManagement from "./invitationManagementReducer"


const rootReducer = combineReducers({
    invitationManagement
});
export default rootReducer;
